import { combineReducers } from 'redux';
import Itinerary from './Itinerary';
import ItineraryCounterReport from './ItineraryCounterReport';
import DelayReason from './DelayReason';
import ItineraryQuality from './ItineraryQuality';
import ServiceMerge from './ServiceMerge';
import UnitHome from './UnitHome';
import ItinerarySearchOmission from './ItinerarySearchOmission';
import LocationForItinerarySearchOmission from './LocationForItinerarySearchOmission';
import ItineraryType from './ItineraryType';
import ItinerarySchedule from './ItinerarySchedule';
import TripStatus from './TripStatus';
import ExtraordinaryMovement from './ExtraordinaryMovement';
import KidsOnItinerary from './KidsOnItinerary';
import ItinerarySalesControl from './ItinerarySalesControl';
import Shift from './Shift';
import TripRequest from './TripRequest';
import Process from './Process';
import BoardingDraft from './BoardingDraft';
import BoardingGroup from './BoardingGroup';
import BusWaitTimeViolation from './BusWaitTimeViolation';
import ItineraryClosureReason from './ItineraryClosureReason';
import ItineraryClosure from './ItineraryClosure';
import ItineraryAdditionalFood from './ItineraryAdditionalFood';
import ItineraryChangeRoute from './ItineraryChangeRoute';
import ItineraryBoardingReport from './ItineraryBoardingReport';

export default combineReducers({
  Itinerary,
  ItineraryCounterReport,
  DelayReason,
  ItineraryQuality,
  ServiceMerge,
  UnitHome,
  ItinerarySearchOmission,
  LocationForItinerarySearchOmission,
  ItineraryType,
  ItinerarySchedule,
  TripStatus,
  ExtraordinaryMovement,
  KidsOnItinerary,
  ItinerarySalesControl,
  Shift,
  TripRequest,
  Process,
  BoardingDraft,
  BoardingGroup,
  BusWaitTimeViolation,
  ItineraryClosureReason,
  ItineraryClosure,
  ItineraryAdditionalFood,
  ItineraryChangeRoute,
  ItineraryBoardingReport
});
